import React from "react";
import { useAuth } from "react-oidc-context";
import { MasterAccountStatuses } from "../../components/forms/selects/MasterAccountStatusSelect";
import { MasterAccountTypes } from "../../components/forms/selects/MasterAccountTypeSelect";
import ClientManagement from "../../features/clientmanagement";
import { toNString } from "../../helpers/guids";
import { FilterProvider } from "../../hooks/FilterContext";
import { useFetchDefaultServiceLevelAgreementsQuery } from "../../services/clientserviceterms";
import { useFetchUsersQuery } from "../../services/identity";
import { Spinner } from "../../components/loaders";
import styled from "styled-components";

const DefaultClientFilters = {
    accountTypes: [MasterAccountTypes.PrivateClient.value],
    accountStatuses: [MasterAccountStatuses.ActiveEnquiry.value, MasterAccountStatuses.ActiveClient.value, MasterAccountStatuses.NoOngoingService.value],
    serviceLevelAgreementIds: [],
    divisionIds: [],
    adviserIds: [],
    reviewAdviserIds: [],
    hideUnfavourited: false,
    surname: "",
    isVulnerable: null,
    vulnerabilityTypeIds: [],
    accompaniedMeetingsDiscussed: null,
    specialStepsRequired: null
}

const FilterSpinner = styled(Spinner)`
    grid-area: main-start;
    justify-self: center;
    align-self: center;
`;

const ClientSearchPage = () => {
    const { user: { profile } } = useAuth();
    const { data: advisers, isFetching: isFetchingAdvisers } = useFetchUsersQuery({ fetchType: 'List', division: null, userType: 'Adviser' });
    const { data: slas, isFetching: isFetchingSlas } = useFetchDefaultServiceLevelAgreementsQuery();
    
    const defaultFilters = React.useMemo(() => {
        let filledDefaults = DefaultClientFilters;

        if (advisers?.results) {
            const currentUserId = toNString(profile.sub);
            const filterOnUser = advisers?.results?.some(adviser => adviser.value === currentUserId);
            if (filterOnUser)
                filledDefaults.adviserIds = [currentUserId];
        }

        if (slas)
            filledDefaults.serviceLevelAgreementIds = slas.map(x => x.agreementId);

        return filledDefaults;
    }, [advisers?.results, profile.sub, slas]);

    const isFetchingFilters = isFetchingAdvisers || isFetchingSlas
    if (isFetchingFilters)
        return <FilterSpinner animation="border" />;

    return (
        <FilterProvider defaultFilters={defaultFilters} filterStore="clientmanagement">
            <ClientManagement />
        </FilterProvider>
    );
};

export default ClientSearchPage;